import {Slider} from '@ds/components';
import {cn} from '@ds/helpers';
import {numberFormat} from 'utils/Helper';

type PriceRangeSliderProps = {
  min: number;
  max: number;
  value: number;
  onChange: (value: number) => void;
  segments: number;
};

const SEGMENT_COLORS = ['bg-red-light-07', 'bg-yellow-butter', 'bg-green-leaf'];

const PriceRangeSlider: React.FC<PriceRangeSliderProps> = ({
  min,
  max,
  value,
  onChange,
  segments
}) => {
  const step = (max - min) / segments;

  const getSegmentClassName = (index: number) => {
    const third = Math.floor(segments / 3);
    if (index < third) {
      return SEGMENT_COLORS[0];
    }
    if (index < 2 * third) {
      return SEGMENT_COLORS[1];
    }
    return SEGMENT_COLORS[2];
  };

  return (
    <div className="relative flex flex-col px-2.5 py-2.5">
      <div className="mt-1 flex justify-between text-body-xs">
        <span className="select-none text-red-soft">عقب‌تر از رقبا</span>
        <span className="select-none text-green-grass">جلوتر از رقبا</span>
      </div>
      <div className="relative z-1 flex h-3 overflow-hidden rounded-sm" aria-hidden>
        {Array.from({length: segments}, (_, index) => (
          <span key={index} className={cn('h-full flex-1', getSegmentClassName(index))} />
        ))}
      </div>
      <Slider
        min={min}
        max={max}
        step={step}
        value={value}
        ariaLabel="هزینه پیشنهادی هر کلیک"
        formatAriaValue={(currentValue) => `${numberFormat(currentValue)} تومان`}
        className="relative z-2"
        onChange={onChange}
      />
      <output className="mt-2.5 flex h-12.5 items-center justify-center bg-gray-02 text-body-sm text-neutral-fg">
        {numberFormat(value)} تومان
      </output>
    </div>
  );
};

export default PriceRangeSlider;
